/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import gp from 'generate-password-browser';

export const generatePassword = (): Promise<string> =>
  Promise.resolve(
    gp.generate({
      numbers: true,
      length: 15,
      lowercase: true,
      uppercase: true,
      symbols: false,
      strict: true,
    }),
  );
